(function () {
	'use strict';

	a3_cabin_reports.controller('FoundPropertyCtrl', FoundPropertyCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name FoundPropertyCtrl
    * @description 
    *  Manages the Special Modal View
    * @ngInject
    */
	function FoundPropertyCtrl($scope, $uibModalInstance, foundProperty) {
        $scope.categories = [
            'Bag',
            'Book',
            'Camera',
            'Charger / Powerbank',
            'Clothing',
            'Cosmetics',
            'Duty Free',
            'Earphones / Headphones',
            'eBook Reader',
            'Footwear',
            'Glasses / Sunglasses',
            'Headwear',
            'Jewellery',
            'Kids / Infant care',
            'Laptop',
            'Medical Item',
            'Mobile Phone',
            'Other',
            'Passport / ID / Documents',
            'Pillow',
            'Tablet',
            'Toy',
            'Umbrella',
            'Videogames',
            'Wallet',
            'Watch'
        ];

        $scope.seats = [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F'
        ];

        $scope.clearFoundPropertyDescription = function() {
            $scope.foundProperty.Description = '';
        };

        $scope.clearFoundPropertyComments = function() {
            $scope.foundProperty.Comments = '';
        };

          $scope.foundProperty = foundProperty || {
            Category: '',
            Description: '',
            Images: [],
            SeatRow: '',
            Seat: '',
            Comments: '',
            Signature: [],
            AgentName: ''
          };
        
          
        $scope.foundProperty.Photos = $scope.foundProperty.Photos || [];

        $scope.addPhotos = function (files) {
          if (!files || !files.length) return;
        
          Array.from(files).forEach(function (file) {
            var reader = new FileReader();
            reader.onload = function (e) {
              $scope.$apply(function () {
                var result = e.target.result;
        
                if (!result || !result.includes(',')) {
                  return;
                }
                var base64Data = result.split(',')[1];
                var fileType = file.type || 'image/png';
        
                $scope.foundProperty.Images = $scope.foundProperty.Images || [];
                $scope.foundProperty.Images.push({
                  PhotoData: base64Data,
                  FileType: fileType
                });
              });
            };
            reader.readAsDataURL(file);
          });
        };
               
        $scope.ok = function () {
          $uibModalInstance.close($scope.foundProperty); // Clean and flat
      };
      
      $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

	}

})();
